import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from '@mui/material';
import { Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';
import { TimePrice } from '../types';

interface TimePriceManagerProps {
  timePrices: TimePrice[];
  onChange: (timePrices: TimePrice[]) => void;
}

const TimePriceManager = ({ timePrices, onChange }: TimePriceManagerProps) => {
  const [newTime, setNewTime] = useState('');
  const [newPrice, setNewPrice] = useState('');

  const handleAdd = () => {
    if (!newTime.trim() || !newPrice.trim()) return;

    const newTimePrice: TimePrice = {
      id: Date.now().toString(),
      time: newTime,
      price: parseFloat(newPrice),
    };

    onChange([...timePrices, newTimePrice]);
    setNewTime('');
    setNewPrice('');
  };

  const handleDelete = (id: string) => {
    onChange(timePrices.filter(tp => tp.id !== id));
  };

  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom>
        Precios por Tiempo
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          label="Tiempo"
          placeholder="ej: 1 mes"
          value={newTime}
          onChange={(e) => setNewTime(e.target.value)}
          size="small"
        />
        <TextField
          label="Precio"
          type="number"
          value={newPrice}
          onChange={(e) => setNewPrice(e.target.value)}
          size="small"
          InputProps={{
            startAdornment: '€',
          }}
        />
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAdd}
          disabled={!newTime.trim() || !newPrice.trim()}
        >
          Añadir
        </Button>
      </Box>

      <List>
        {timePrices.map((tp) => (
          <ListItem key={tp.id}>
            <ListItemText
              primary={tp.time}
              secondary={`${tp.price}€`}
            />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                onClick={() => handleDelete(tp.id)}
                color="error"
              >
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default TimePriceManager;